import { ExpenseBankingTransactionForExpenseDetailFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export const transactionURL = (
  transaction: ExpenseBankingTransactionForExpenseDetailFragment,
  navigation: ReturnType<typeof useNavigation>['navigation']
) => {
  return navigation.finance.banking.accounts.accountId.transactions.transactionId.fullPath({
    id: transaction.bankAccountId,
    transaction_id: transaction.id,
  })
}
